import { Customer, FormField } from "@jugl-web/rest-api";
import { customerPhoneStringToInputValue } from "@jugl-web/ui-components";

const findCustomerField = (
  customer: Customer,
  field: "first_name" | "last_name"
) => {
  const foundField = customer?.fields.find(
    (data: { field: FormField; value: string | null }) =>
      data.field.name === field
  );

  if (foundField) return foundField.value;
  return "";
};

export const customerToBillToString = (customer?: Customer | null): string => {
  if (!customer) {
    return "";
  }
  const name = [
    findCustomerField(customer, "first_name"),
    findCustomerField(customer, "last_name"),
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  const additionalFields: string[] = [];
  customer?.fields.forEach((field) => {
    if (!field.value) return;
    if (
      field.field.name !== "first_name" &&
      field.field.name !== "last_name" &&
      field.field.name !== "lead_source"
    ) {
      if (field.field.type === "mobile") {
        const { phone, code } = customerPhoneStringToInputValue(field.value);
        additionalFields.push(`${code}${phone}`);
        return;
      }
      if (field.field.type === "dropdown") {
        const fieldValue = field.field.values?.find(
          (value) => value.id === field.value || value.value === field.value
        )?.value;

        if (!fieldValue) return;
        additionalFields.push(fieldValue || "");
        return;
      }

      additionalFields.push(field.value);
    }
  });
  return [name, ...additionalFields].filter(Boolean).join("\n").trim();
};
